/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Hike',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M17.831 21.437a.6.6 0 1 1-1.2 0v-9.251h.63a.87.87 0 0 0 .569-.211v9.462zm-5.117-6.371a2.67 2.67 0 0 1 .588.924l2.08 4.516a1.08 1.08 0 0 1-.672 1.387 1.07 1.07 0 0 1-.357.063c-.462 0-.883-.294-1.051-.735l-1.666-3.615 1.078-2.538zM9.407 6.208c.458 0 .834.352.872.801h1.461c.81 0 1.175.422 2.456 2.283.063.084.24.309.366.33h2.436c.461 0 .966.215.966.92 0 .617-.431.996-.966.996h-3.25c-.447 0-.745-.545-.926-.815l-.446-.657-.372 3.931.001.002-.366.996.002.001-1.09 2.46c-.077.227-.219.439-.33.65l-2.024 3.033c-.301.443-.589.714-1.029.714a1.19 1.19 0 0 1-.378-.062c-.567-.21-.948-.956-.652-1.407l2.162-3.19c.096-.141.171-.326.196-.494l.438-1.705c.093-.361-.08-.727-.284-1.04a1.74 1.74 0 0 1-.252-.724h-.562c-.725 0-1.313-.588-1.313-1.312v-3.96a1.75 1.75 0 0 1 1.751-1.751h1.134zm7.825.788a.6.6 0 0 1 .6.6v1.566c-.153-.131-.352-.211-.569-.211h-.63V7.596a.6.6 0 0 1 .6-.6zm-5.111-5.02a2.122 2.122 0 1 1-.459 4.219c-1.165-.127-2.006-1.174-1.88-2.339s1.174-2.006 2.339-1.88z" />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
